export class SlackReactionNotFoundError extends Error {}
